import { render } from "./TrackShipment.vue?vue&type=template&id=ecb34186&scoped=true"
import script from "./TrackShipment.vue?vue&type=script&lang=js"
export * from "./TrackShipment.vue?vue&type=script&lang=js"

import "./TrackShipment.vue?vue&type=style&index=0&id=ecb34186&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb34186"]])

export default __exports__